
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ApiHandlerService } from 'projects/b2c/src/app/core/api-handlers';
import { UtilityService } from 'projects/b2c/src/app/core/services/utility.service';
import { SubSink } from 'subsink';
import { HotelService } from '../../../../hotel.service';
import { LowBalanceAlertComponent } from '../low-balance-alert/low-balance-alert.component';
import { HttpErrorResponse } from '@angular/common/http';
import { SwalService } from 'projects/b2c/src/app/core/services/swal.service';
import { AppGlobal } from 'projects/b2c/src/app/app.global';
declare const $: any;
@Component({
    selector: 'app-hotel-guest-details',
    templateUrl: './hotel-guest-details.component.html',
    styleUrls: ['./hotel-guest-details.component.scss']
})
export class HotelGuestDetailsComponent implements OnInit {

    nights: any;
    currentUser: any;
    travellerForm: FormGroup;
    addressForm: FormGroup;
    titleListAdult: any = [];
    titleListChild: any = [];
    selectedTitle;
    hotel: any;
    traveller: any;
    noOfAdults: number = 0;
    noOfChilds: number = 0;
    noOfAdultsExt: number = 0;
    noOfChildsExt: number = 0;
    roomWiseAdultsChilds = [];
    guestData: any = {};
    countries: Array<any> = [];
    private subSunk = new SubSink();
    regConfig: FormGroup;
    submitted: boolean = false;
    lastKeyupTstamp: number = 0;
    openRooms: boolean = false;
    adults: number[] = [1];
    childs: number[] = [0];
    noOfRooms: number = 1;
    maxDateAdult: Date;
    minChildDate: Date;
    maxChildDate: Date;
    minDate = new Date();
    bsConfig: Partial<BsDatepickerConfig> = {
        isAnimated: true,
        dateInputFormat: 'DD-MM-YYYY',
        rangeInputFormat: 'DD-MM-YYYY',
        showWeekNumbers: false,
        containerClass: 'theme-default',
    };
    isLoading: boolean = false;
    guestCountData: {} = {};
    phoneCodes: any;
    titleList: any;
    respData: any = [];
    noOfRoomArr = [];
    browserRefresh: boolean;
    loading: boolean;
    loadingTemplate: any;
    primaryColour: any;
    secondaryColour: any;
    isInvalidPromo: boolean = false;
    txtCouponCodeValue: string = ''; // Variable to hold the input value
    disableApplyPromo: boolean = false;
    protected subs = new SubSink();
    promocodeList: any = [];
    selectedPromocode = '';
    promocode: any;
    discount_value: number = 0.00;
    booking_source: any;
    constructor(
        private apiHandlerService: ApiHandlerService,
        private fb: FormBuilder,
        private router: Router,
        private hotelService: HotelService,
        private util: UtilityService,
        private dialog: MatDialog,
        private cdRef: ChangeDetectorRef,
        private swalService: SwalService,
        private appGlobal: AppGlobal,
    ) { }

    ngOnInit() {
        this.getTitleList();
        this.currentUser = JSON.parse(sessionStorage.getItem('b2cUser'));
        if (this.currentUser) {
            this.getTravellersList();
        }
        this.getPromoCodeList();
        this.setHotelTraveller();
        this.setblockHotelRoomState();
        this.subSunk.sink = this.hotelService.blockHotelRoom.subscribe(res => {
            this.hotel = res.data;
            console.log("this.hotel",this.hotel)
        })
        this.traveller = this.hotelService.traveller;
        this.getCountryList();
        this.getPhoneCodeList();
        this.createTravellerForm();
        this.nights = (new Date(this.hotel.CheckOut).getTime() - new Date(this.hotel.CheckIn).getTime()) / (1000 * 60 * 60 * 24);
        if (this.currentUser.agent_balance <= 50) {
            this.dialog.open(LowBalanceAlertComponent, {
                data: this.currentUser.agent_balance
            });
        }
        this.maxDateAdult = this.addYearsToDate(-12);
        this.maxChildDate = this.addYearsToDate(-2);
        this.subs.sink = this.hotelService.hotelPromocode.subscribe(res => {
            if (res && Object.keys(res).length > 0) {
                this.promocode = res['promocode'];
                if (this.promocode && this.promocode != "") {
                    if (this.promocode.discount_type == "percentage") {
                        let amount: number
                        amount = (this.promocode.discount_value / 100);
                        this.discount_value = (this.hotel.Price.Amount * amount);
                    }
                    if (this.promocode.discount_type == "plus") {
                        this.discount_value = this.promocode.discount_value;
                    }
                }
                else {
                    this.discount_value = 0;
                }

            }
            this.cdRef.detectChanges();
        });
    }

    addYearsToDate(y: number) {
        const d = new Date();
        const year = d.getFullYear();
        const month = d.getMonth();
        const day = d.getDate();
        const c = new Date(year + y, month, day);
        return c;
    }

    createTravellerForm() {
        this.travellerForm = this.fb.group({
            rooms: this.fb.array([]),
            adults: this.fb.array([]),
            childs: this.fb.array([]),
            address: this.fb.array([this.addAddressForm()]),
            Aggreed: new FormControl(false, [Validators.required])
        });
        this.addAdults();
    }

    addAdults() {
        this.traveller.forEach((element, index) => {
            this.noOfAdults += element.adults;
            this.noOfChilds += element.childrens;

            this.noOfRooms += 1;
            this.noOfRoomArr.push(1)

            for (let i = 0; i < element.adults; i++) {
                if (this.travellerForm.value['adults'].length < this.noOfAdults) {
                    this.trevellers('adults').push(this.addTravellers(index + 1));
                }
            }
            for (let i = 0; i < element.childrens; i++) {
                if (this.trevellers('childs').length < this.noOfChilds) {
                    this.trevellers('childs').push(this.addChildTravellersFrom(index + 1));
                }
            }
        });
    }
    
    getPhoneCodeList() {
        this.subSunk.sink = this.apiHandlerService.apiHandler('phoneCodeList', 'POST')
            .subscribe(res => {
                if (res && res.data.length) {
                this.phoneCodes = res.data;
                this.cdRef.detectChanges();

                }
            });
    }

    getCountryList(): void {
        this.subSunk.sink = this.apiHandlerService.apiHandler('countryList', 'post', {}, {}, {}).subscribe(resp => {
            if (resp.statusCode == 200 && resp.data) {
                this.countries = resp.data.countries;
                this.cdRef.detectChanges();
            }
        })
    }

    getTitleList() {
        this.subSunk.sink = this.apiHandlerService.apiHandler('userTitlelist', 'post', {}, {}, {}).subscribe(res => {
            this.hotelService.userTitleList.next(res.data);
            if (res.data.length) {
                this.titleList = res.data;
                this.cdRef.detectChanges();
            }
        });
    }

    addTravellers(room?: number): FormGroup {
        return this.fb.group({
            Title: new FormControl('', [Validators.required]),
            FirstName: new FormControl('', [Validators.required, Validators.maxLength(30), Validators.minLength(1), Validators.pattern(this.util.regExp.fullName)]),
            LastName: new FormControl('', [Validators.maxLength(30), Validators.minLength(2), Validators.pattern(this.util.regExp.userName)]),
            Dob: new FormControl('', [Validators.required]),
            PassengerSelectionAdult:'',// Used for passenger selection
            RoomId:room,
        })
    }

    addChildTravellersFrom(room?: number): FormGroup {
        return this.fb.group({
            Title: new FormControl(''),
            FirstName: new FormControl('', [Validators.maxLength(30), Validators.minLength(1), Validators.pattern(this.util.regExp.fullName)]),
            LastName: new FormControl('', [Validators.maxLength(30), Validators.minLength(2), Validators.pattern(this.util.regExp.userName)]),
            Dob: new FormControl(''),
            PassengerSelectionChild:'',
            RoomId:room,
        })
    }

    addAddressForm(): FormGroup {
        return this.fb.group({
            Title: new FormControl('', [Validators.required]),
            FirstName: new FormControl('', [Validators.required, Validators.maxLength(30), Validators.minLength(1), Validators.pattern(this.util.regExp.fullName)]),
            LastName: new FormControl('', [Validators.required, Validators.maxLength(30), Validators.minLength(1), Validators.pattern(this.util.regExp.userName)]),
            Address: new FormControl('', [Validators.required,]),
            Address2: new FormControl('', [Validators.maxLength(120), Validators.minLength(2)]),
            City: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]),
            State: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]),
            PostalCode: new FormControl('', [Validators.required, Validators.pattern(this.util.regExp.zipCode), Validators.maxLength(10)]),
            Email: new FormControl(this.currentUser?.email || '', [Validators.required, Validators.minLength(5), Validators.maxLength(30), Validators.pattern(this.util.regExp.email)]),
            // PhoneCode: new FormControl('', [Validators.required]),
            PhoneCode: new FormControl(this.currentUser?.phone_code || '1', [Validators.required, Validators.maxLength(6)]),
            Contact: new FormControl(this.currentUser?.phone || '', [Validators.required, Validators.pattern(this.util.regExp.phoneNo)]),
            Country: new FormControl('USA', [Validators.required])
        })
    }

    trevellers(controlName: string): FormArray {
        return this.travellerForm.get(controlName) as FormArray;
    }

    addAdultTravellers() {
        if (this.travellerForm.value['adults'].length < this.noOfAdults) {
            this.trevellers('adults').push(this.addTravellers());
        }
    }

    addChildTravellers() {
        if (this.trevellers('childs').length < this.noOfChilds) {
            this.trevellers('childs').push(this.addChildTravellersFrom());
        }
    }

    removeAdultTravellers(index?): void {
        if (this.trevellers('adults').length > 1) {
            this.trevellers('adults').removeAt(index);
        }
    }

    removeChildTravellers(index?): void {
        if (this.trevellers('childs').length > 0) {
            this.trevellers('childs').removeAt(index);
        }
    }

    hasError = (controlName: string, errorName: string, arrayControl?: string, i?: number) => {
        if (typeof arrayControl !== 'undefined') {
            let formArrayName = this.travellerForm.get(arrayControl) as FormArray;
            return ((this.submitted || formArrayName.controls[i]['controls'][controlName].touched) && formArrayName.controls[i]['controls'][controlName].hasError(errorName));
        } else {
            return ((this.submitted || this.travellerForm.controls[controlName].touched) && this.travellerForm.controls[controlName].hasError(errorName));
        }
    }

    getStarArray(num) {
        num = Number(num);
        let starArr = [];
        if (num && num >= 0)
            starArr.length = Math.round(num);
        return starArr;
    }

    getStarArrayRemaining(num) {
        num = Number(num);
        let starArr = [];
        if (num && num >= 0)
            starArr.length = 5 - Math.round(num);
        return starArr;
    }

    onSubmit() {
        this.submitted = true;
        if (!this.currentUser) {
            // If the user is not logged in, open the login modal
            $("#show_log").modal('show');
            return;
          }
        if (!this.hotelService.isDevelopment) {
            if (!this.travellerForm.valid)
                return;
        }
        this.hotelService.loading.next(true);
        this.loading=true;
        let passengerDetails = [];
        this.travellerForm.get('adults').value.forEach((adult, i) => {
            let age;
            if (adult['Dob'] != "") {
                age = this.util.calculateAge(adult['Dob']);
                adult['Dob'] = formatDate(adult['Dob'], 'YYYY-MM-DD');
            } else adult['Dob'] = ""

            adult = Object.assign(adult, { Age: age, PaxType: '1', LeadPassenger: i == 0 ? true : false })
            passengerDetails.push(adult);
        });
        this.travellerForm.get('childs').value.forEach(child => {
            let age;
            if (child['Dob'] != "") {
                age = this.util.calculateAge(child['Dob']);
                child['Dob'] = formatDate(child['Dob'], 'YYYY-MM-DD');
            } else child['Dob'] = ""
            child = Object.assign(child, { Age: age, PaxType: '0', LeadPassenger: false })
            passengerDetails.push(child);
        });
        let date = (new Date().getTime()).toString();
        let AppReference = `HB${date.substr(10)}-${date.substr(0, 7)}-${date.substr(7)}`

        let reqBody = {
            ResultToken: `${this.hotel['ResultToken']}`,
            BlockRoomId: 0,
            AppReference: AppReference,
            UserId: sessionStorage.getItem('b2cUser') ? JSON.parse(sessionStorage.getItem('b2cUser'))['id'] : 0,
            RoomDetails: [
                {
                    PassengerDetails: passengerDetails,
                    AddressDetails: this.travellerForm.get('address').value[0],
                }
            ],
            booking_source: "ZBAPINO00008",
            BookingSource: 'B2C',
            Currency: this.appGlobal.selectedCurrency.value,
            PromoCode: this.selectedPromocode,
        }

        this.subSunk.sink = this.apiHandlerService.apiHandler('createAppReference', 'POST', '', '', {
            module: "hotel"
        }).subscribe(res => {
            if ((res.statusCode == 200 || res.statusCode == 201) && res.data) {
                reqBody['AppReference'] = res.data;
                this.subSunk.sink = this.apiHandlerService.apiHandler('addPaxDetails', 'post', {}, {}, reqBody).subscribe(resp => {
                    if (resp.statusCode == 200 || resp.statusCode == 201) {
                        this.loading =false;
                        this.hotelService.addHotelBookingPaxDetails.next(resp.data);
                        localStorage.setItem("hotelCommitBookingResponse",JSON.stringify(resp.data));
                        this.router.navigate(['/hotel-payment'], { queryParams: { appReference: reqBody['AppReference'], bookingSource: this.hotel['booking_source'] } });
                        // this.hotelBookingService.isButtonClickedInTraveler.next(true);
                    }
                }, err => {
                    this.loading=false;
                    this.swalService.alert.oops(err.error.Message);
                    console.error(err);
                })
                this.hotelService.loading.next(false);
            }
        },err => {
            this.swalService.alert.oops(err.error.Message);
            this.loading=false;
            console.error(err);
        })

        this.hotelService.loading.next(false);
    }

    setAdultDetails(passengerDetails,index,selectedSection) {
        this.setPassengerTitle(passengerDetails,selectedSection);
            this.travellerForm.controls['adults']['controls'][index].patchValue({
                Title:this.selectedTitle,
                FirstName:passengerDetails.first_name.toUpperCase(),
                LastName:passengerDetails.last_name.toUpperCase(),
                Dob:new Date((new Date(passengerDetails.date_of_birth))),
                Room: new FormControl(index || 0)
            });
       }

       setChildDetails(passengerDetails,index,selectedSection) {
        this.setPassengerTitle(passengerDetails,selectedSection);
            this.travellerForm.controls['childs']['controls'][index].patchValue({
                Title:this.selectedTitle,
                FirstName:passengerDetails.first_name.toUpperCase(),
                LastName:passengerDetails.last_name.toUpperCase(),
                Dob:new Date((new Date(passengerDetails.date_of_birth))),
                Room: new FormControl(index || 0)
            });
       }

       setPassengerTitle(passengerDetails, selectedSection) {
        let titleArray;
        if (selectedSection === 'adults') {
            titleArray = this.titleList.filter(element => (element.paxType === "ADULT" && element.titleName === passengerDetails.title));
        }
        else {
            titleArray = this.titleList.filter(element => (element.paxType === "CHILD" && element.titleName === passengerDetails.title));
        }
        if (titleArray.length == 0) {
            this.selectedTitle= "";
        }else
        {
            this.selectedTitle=passengerDetails.title;
        }
    }

    clearAdultDetails(index,selectedIndex) {
        this.travellerForm.controls['adults']['controls'][index].patchValue({
            Title: '',
            FirstName: '',
            LastName: '',
            Dob:'',
            Room: index,
            PassengerSelectionAdult:''
        });
    }

    clearChildDetails(index,selectedIndex) {
        this.travellerForm.controls['childs']['controls'][index].patchValue({
            Title: '',
            FirstName: '',
            LastName: '',
            Dob:'',
            Room: index,
            PassengerSelectionChild:''
        });
    }

    getTravellersList() {
        this.apiHandlerService.apiHandler("userTravellersList", "POST").subscribe((res) => {
             if (res && res.data.length) {
              this.respData = res.data;
               this.cdRef.detectChanges();
             }
           });
       }

    openStaticPage(page_title) {
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['cms/' + page_title])
        );
        window.open('#' + url, '_blank');
    }

    setblockHotelRoomState(){
        const storedState = localStorage.getItem('blockHotelRoomState');
        if (storedState) {
            this.hotelService.blockHotelRoom.next(JSON.parse(storedState));
        }
    }
   
    setHotelTraveller(){
        this.hotelService.setHotelTraveller();
    }

    
    setPromoCode(promocode) {
        this.selectedPromocode = promocode.promo_code;
        this.hotelService.hotelPromocode.next({
            promocode: promocode
        });
        localStorage.setItem('hotelPromocode', JSON.stringify(promocode));
    }

    setSelectedPromo(promocode, index) {
        this.promocodeList.forEach((code, i) => {
            code.selected = (i === index); // Set selected to true only for the clicked index
        });
        this.txtCouponCodeValue = `${promocode.promo_code}`;
        this.isInvalidPromo = false;
        this.disableApplyPromo = true;
        this.cdRef.detectChanges();
        this.setPromoCode(promocode);
    }

    removePromoCode() {
        this.hotelService.hotelPromocode.next({
            promocode: ''
        });
        this.txtCouponCodeValue="";
        localStorage.setItem('hotelPromocode', JSON.stringify(''));
    }


    getPromoCodeList() {
        this.subs.sink = this.apiHandlerService.apiHandler('listPromocode','POST', '', '', { Currency: this.appGlobal.selectedCurrency.value })
            .subscribe(res => {
                if (res) {
                    this.promocodeList = res.data.filter(element => element.category == 'Hotel');
                    this.cdRef.detectChanges();
                }
            });
    }

    removeSelectedPromo() {
        // Assuming this.promocodeList is an array of objects with a 'selected' property
        for (let i = 0; i < this.promocodeList.length; i++) {
            this.promocodeList[i].selected = false;
        }
        // Reset the radio button selection
        const radioButtons = document.getElementsByName("cpnRadio");
        for (let i = 0; i < radioButtons.length; i++) {
            const radioButton = radioButtons[i] as HTMLInputElement;
            radioButton.checked = false;
        }
        this.selectedPromocode = "";
        this.txtCouponCodeValue="";
        this.disableApplyPromo = false;
        this.cdRef.detectChanges();
        this.hotelService.hotelPromocode.next({
            promocode: ''
        });
        localStorage.setItem('hotelPromocode', JSON.stringify(''));
    }

    applyCoupon() {
        if (!this.txtCouponCodeValue) {
            return;
          }
        this.hotelService.loading.next(true);
        let coupon = this.txtCouponCodeValue;
        // this.removeSelectedPromo();
        let request = {
          promocode: this.txtCouponCodeValue,
          category: "Hotel"
        };
        
        this.apiHandlerService.apiHandler('getPromoCodeInfo', 'POST', '', '', request).subscribe(response => {
          if ((response.statusCode == 200 || response.statusCode == 201) && response.data && response.data[0]) {
            this.disableApplyPromo = true;
            this.isInvalidPromo = false;
            this.hotelService.loading.next(false);
            this.cdRef.detectChanges();
            this.setPromoCode(response.data[0]);
          } else {
            this.handleInvalidPromoCode();
          }
        }, (error) => {
          this.handleInvalidPromoCode();
        });
      }
    
      handleInvalidPromoCode() {
        this.disableApplyPromo = false;
        this.txtCouponCodeValue = '';
        this.isInvalidPromo = true;
        this.hotelService.loading.next(false);
        this.cdRef.detectChanges();
      }


    ngOnDestroy(): void {
        this.subSunk.unsubscribe();
    }
}
